import { useMemo, useCallback } from 'react';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

const { EVENT_WISHLIST } = eventNameConstants;
const { INTERACTION_TYPE_ITEM_FAVORITING } = interactionTypeConstants;
const {
    STEP_INTERACTION_ITEM_ADDED_TO_FOLDER,
    STEP_INTERACTION_ITEM_FOLDER_CLICKED,
    STEP_INTERACTION_ITEM_FOLDER_CREATED,
    STEP_INTERACTION_ITEM_REMOVED_FROM_FOLDER,
} = stepInteractionConstants;

export const useFolderTracking = (
    trigger?: string
): {
    trackFolderClick: () => void;
    trackItemRemoved: () => void;
    trackItemAdded: (noteIncluded?: boolean, itemPk?: string | null) => void;
    trackFolderCreated: (noteIncluded?: boolean) => void;
} | null => {
    const trackFolderEvent = useCallback(
        (
            step_interaction_name: string,
            noteIncluded = false,
            itemPk: string | null = null
        ): void => {
            if (!trigger) {
                return;
            }
            trackEvent(
                {
                    label: trigger,
                    action: step_interaction_name,
                    category: INTERACTION_TYPE_ITEM_FAVORITING,
                    value: noteIncluded ? 1 : 0,
                    isInteractiveEvent: true,
                    additional: itemPk ? { itemPk } : {},
                    eventName: EVENT_WISHLIST,
                    interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
                    step_interaction_name,
                    trigger,
                },
                null
            );
        },
        [trigger]
    );

    const value = useMemo(
        () =>
            trigger
                ? {
                      trackFolderClick: () =>
                          trackFolderEvent(STEP_INTERACTION_ITEM_FOLDER_CLICKED),
                      trackItemRemoved: () =>
                          trackFolderEvent(STEP_INTERACTION_ITEM_REMOVED_FROM_FOLDER),
                      trackItemAdded: (
                          noteIncluded: boolean = false,
                          itemPk: string | null = null
                      ) => {
                          const hasNoteIncluded = noteIncluded ? 1 : 0;
                          trackEvent(
                              {
                                  label: trigger,
                                  action: STEP_INTERACTION_ITEM_ADDED_TO_FOLDER,
                                  category: INTERACTION_TYPE_ITEM_FAVORITING,
                                  value: hasNoteIncluded,
                                  isInteractiveEvent: true,
                                  additional: itemPk ? { itemPk } : {},
                                  eventName: EVENT_WISHLIST,
                                  interaction_type: INTERACTION_TYPE_ITEM_FAVORITING,
                                  step_interaction_name: STEP_INTERACTION_ITEM_ADDED_TO_FOLDER,
                                  trigger,
                                  step_type: hasNoteIncluded,
                              },
                              null
                          );
                      },
                      trackFolderCreated: (noteIncluded: boolean = false) => {
                          trackFolderEvent(STEP_INTERACTION_ITEM_FOLDER_CREATED, noteIncluded);
                      },
                  }
                : null,
        [trigger, trackFolderEvent]
    );

    return value;
};
